terms:
  title: Algemene voorwaarden
privacy:
  title: Privacyverklaring
actions:
  download: Download PDF
